<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<path d="M10,4c0-2.2-1.8-4-4-4S2,1.8,2,4c0,0.7,0.2,1.4,0.6,2C2.2,6.6,2,7.3,2,8c0,2.2,1.8,4,4,4s4-1.8,4-4c0-0.7-0.2-1.4-0.6-2C9.8,5.4,10,4.7,10,4z M6,1c1.7,0,3,1.3,3,3S7.7,7,6,7S3,5.7,3,4S4.3,1,6,1z" />
</svg>
</template>